rs.module("controls/diagnostics/logviewer/logparser", [], function () {
    // 1 = time, 2 = level, 3 = source,  4 = text
    var logRegex = /(\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}\.\d{3})\s-?\d{2}:\d{2}\s\[([^\]]+)]\s\[([^\]]+)]\s+(.*)$/;

    function parseLog(line) {

        // first peel off the properties from the end of the string
        let lastBrace = line.lastIndexOf("}");
        let splitIndex = -1;
        let currentIndex = -1;
        if (lastBrace > -1) {
            currentIndex = lastBrace;
            let nesting = 1;

            // cycle backwards through the string looking for the outermost opening curly brace
            while (--currentIndex >= 0 && nesting > 0) {
                let currentChar = line.charAt(currentIndex);
                if (currentChar === '}') {
                    nesting++;
                }
                else if (currentChar === '{') {
                    nesting--;
                }
            }

            if (nesting === 0) {
                splitIndex = currentIndex;
            }
        }

        let properties = null;
        if (splitIndex > -1) {
            properties = line.substring(currentIndex + 1);
            line = line.substring(0, currentIndex);
        }

        let [, time, level, source, text] = line.match(logRegex) || [];

        if (time) {
            return {
                time: time,
                level: level,
                source: source,
                messageOnly: false,
                message: text,
                properties: properties
            };
        }
        else {
            return {
                messageOnly: true,
                message: line
            };
        }
    }

    function fixArrayContents(text) {
        // change ( to { and ) to }, as long as they aren't inside strings
        var inQuotes = false;
        var fixed = [];
        var index = 0;

        while (index < text.length) {
            var currentChar = text.charAt(index);

            if (currentChar === '"') {
                inQuotes = !inQuotes;
            }

            if (!inQuotes) {

                if (currentChar === '(') {

                    fixed.push('{');
                }
                else if (currentChar === ')') {
                    fixed.push('}');
                }
                else {
                    fixed.push(currentChar);
                }
            }
            else {
                fixed.push(currentChar);
            }

            index++;
        }

        return fixed.join('');
    }

    function fixArray(text, index) {
        var i = index;
        var bracketCount = 0;
        while (i < text.length) {
            var currentChar = text.charAt(i);
            if (currentChar === '[') {
                bracketCount++;
            }
            else if (currentChar === ']') {
                bracketCount--;
            }

            if (bracketCount === 0) {
                break;
            }
            else {
                i++;
            }
        }

        if (bracketCount === 0) {
            return {
                text: fixArrayContents(text.substring(index, Math.min(i + 1, text.length))),
                endIndex: i
            };
        }
        else {
            return {
                text: text,
                endIndex: i
            };
        }
    }

    // The log format (serilog) uses almost-JSON.  Its keys aren't quoted, so we can't just use JSON.parse.
    // this will add the necessary quotes around keynames
    function propertiesToJSON(propertyString) {
        // serilog can contain a nested "array" of sorts
        var fixedForArrays = [];
        var i = -1;
        var inQuotes = false;

        while (i < propertyString.length) {
            i++;
            var currentChar = propertyString.charAt(i);

            if (currentChar === '"') {
                inQuotes = !inQuotes;
            }
            if (currentChar === '[' && !inQuotes) {
                var fixedSubString = fixArray(propertyString, i);

                // add all fixedSubString
                fixedForArrays.push(fixedSubString.text);
                i = fixedSubString.endIndex;
                continue;
            }


            fixedForArrays.push(currentChar);
        }
        propertyString = fixedForArrays.join('');

        return propertyString.replace(/\s([\w\s]+(?:[^"]))\s*\:(?!\S*")/g, ' "$1":');
	}

	var exports = {
		parseLog: parseLog,
		propertiesToJSON: propertiesToJSON
	};

	return exports;
}
);